<div class="dx-field" style="width: 515px;">
    <div class="dx-field-value">
      <dx-tag-box 
      [items]="dataSource" 
      [searchEnabled]="true"
      displayExpr="name"
      valueExpr="id"
      (onValueChanged)="onValueChanged($event)" 
      [(ngModel)]="value"
      [disabled] ="disabled"
      [(required)]="isRequired">
      </dx-tag-box>
    </div>
  </div>

